import { render, staticRenderFns } from "./BaseLayoutWithoutLogo.vue?vue&type=template&id=5387175a"
import script from "./BaseLayoutWithoutLogo.vue?vue&type=script&lang=js"
export * from "./BaseLayoutWithoutLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports